/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateEconomicVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createEconomicVerificationKeyMutationVariables = {
    input: CreateEconomicVerificationKeyInput;
};
export type createEconomicVerificationKeyMutationResponse = {
    readonly createEconomicVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type createEconomicVerificationKeyMutation = {
    readonly response: createEconomicVerificationKeyMutationResponse;
    readonly variables: createEconomicVerificationKeyMutationVariables;
};



/*
mutation createEconomicVerificationKeyMutation(
  $input: CreateEconomicVerificationKeyInput!
) {
  createEconomicVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateEconomicVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateEconomicVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createEconomicVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createEconomicVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createEconomicVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createEconomicVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createEconomicVerificationKeyMutation(\n  $input: CreateEconomicVerificationKeyInput!\n) {\n  createEconomicVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = '914545c58642fdbb15b682128759df80';
export default node;
